var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4874 2.504H23.0004V6.783H20.4954V24H3.27841V6.783H0.774414V2.504H7.76541V0H15.4874V2.504ZM14.2354 1.252H9.01743V2.504H14.2354V1.252ZM20.3914 5.52999H21.7484V3.65199H2.02643V5.52999H20.3914ZM7.45242 6.783H4.42642V22.748H7.45242V6.783ZM8.70441 22.748H11.2084V6.783H8.70441V22.748ZM14.8614 22.748V6.783H12.3564V22.748H14.8614ZM16.2174 22.748H19.2434V6.783H16.2174V22.748Z",
    fill: "#455A64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.218a511207bd1008d46e13e26d6755a2.svg";
export { ForwardRef as ReactComponent };